export function ensureDoctorPrefix(name?: string | null): string {
  const value = (name || '').trim();
  if (!value) return '—';
  return /^dr\.?\s+/i.test(value) ? value : `Dr. ${value}`;
}
